import { render, staticRenderFns } from "./project-boxs.vue?vue&type=template&id=e205bb36&scoped=true&"
import script from "./project-boxs.vue?vue&type=script&lang=js&"
export * from "./project-boxs.vue?vue&type=script&lang=js&"
import style0 from "./project-boxs.vue?vue&type=style&index=0&id=e205bb36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e205bb36",
  null
  
)

export default component.exports